import src from "IMAGE";
export default { src, width: 209, height: 256, blurWidth: 0, blurHeight: 0};
